// extracted by mini-css-extract-plugin
export var copyableItem = "_4c-0";
export var underlined = "_4c-1";